enum ProductPricing {
  Average = 'Average',
  Minimum = 'Minimum',
  Maximum = 'Maximum',
  Fixed = 'Fixed',
}

export default ProductPricing;
